import { Box, Button, FormLabel, styled } from "@mui/material";
import styled2 from "@emotion/styled";

const LoginButton = styled(Button)(() => ({
    backgroundColor: '#2a01cfff',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '3rem',
    width: '8rem',
    borderRadius: '100rem',
}));

const LoginTitleField = styled(Box)(() => ({
    fontWeight: 'bold',
    fontSize: '2rem'
}));

const InputFormLabel = styled(FormLabel)(() => ({
    fontWeight: 'bold',
    fontSize: '1rem',
    marginRight: '2rem'
}));

const InputFormField = styled(Box)(() => ({
    position: 'absolute',
    left: 'calc(100% - 97%)',
    top: 'calc(100% - 75%)'
}));

const InputIndividualField = styled(Box)(() => ({
    marginTop: '1rem'
}));

const LoginButtonField = styled(Box)(() => ({
    position: 'absolute',
    right: 'calc(100% - 97%)',
    top: 'calc(100% - 30%)'
}));

const Footer = styled2.footer`
    overflow: auto;
    color: #5C6670;
    width: 100%;
    font-size: 1.2rem;
    margin: 0 auto;
    margin-bottom: 4rem;
    padding-top: 0.5rem;
    text-align: center;
    position: absolute;
    bottom: 0; 
`;

const Header = styled2.header`
    overflow: auto;
    width: 100%;
    font-size: 1.2rem;
    margin: 0 auto;
    margin-top: 6rem;
    padding-top: 0.5rem;
    text-align: center;
    position: absolute;
    top: 0; 
`;

export { LoginButton, LoginTitleField, InputFormField, InputFormLabel, LoginButtonField, InputIndividualField, Footer, Header }
